export class AnalyticFilterModel {
  constructor(
    public Commodity_id: number = 0,
    public Region_id: number = 0,
    public center_id: number = 0,
    public dateTo: string = '',
    public dateFrom: string= ''
    ) {
  }
}

export interface AnalyticsFilter {
  commodity__id: number;
  region_id: number;
  installationcenter_id: number;
  DateTo: Date;
  dateFrom: Date;
}

export interface FilterParamsApiModel {
  p?: number;
  l?: number;
  customer_id?: number;
  commodity_id: number;
  inst_center_id?: number;
  region_id?: number;
  date_from?: number;
  date_to?: number;
}
